import useUser from '../global/useUser';
import { DEFAULT_QUEUE_SETTINGS } from '../../constants/queue';

function useQueueSettings() {
  const { user } = useUser();

  return user?.business?.queueSettings ?? DEFAULT_QUEUE_SETTINGS;
}

export default useQueueSettings;
